import React from "react";
import {TextField,} from "@mui/material";

export default function DHTextFieldSearch({id, label, width, value, variant, onChange}) {

    return <TextField id={id} label={label} variant={variant ? variant : "standard"} style={{width: width}} type="search" required={false} value={value} onChange={(event) => onChange(event.target.value)}/>

}